// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientConsentPreview_root__1hwuB","description":"PatientConsentPreview_description__1GvUc"};